"use client";

import BrandedPrototypeSelector from "@/shared/ui/controls/BrandedPrototypeSelector";
import type { MindstringPrototype } from "@/generated/fastapi";
import type {
  StudioPrototypeOption,
  StudioPrototypeTone,
} from "./studioChrome.types";

type StudioPrototypeSwitcherProps = {
  activePrototypeCategory: MindstringPrototype;
  options: StudioPrototypeOption[];
  tone: StudioPrototypeTone;
  onPrototypeCategoryChange: (value: MindstringPrototype) => void;
};

export default function StudioPrototypeSwitcher({
  activePrototypeCategory,
  options,
  tone,
  onPrototypeCategoryChange,
}: StudioPrototypeSwitcherProps) {
  void tone;

  return (
    <BrandedPrototypeSelector
      activePrototype={activePrototypeCategory}
      options={options}
      onChange={onPrototypeCategoryChange}
      ariaLabel="Switch Studio perspective"
      showCounts={true}
      showDescriptions={true}
      triggerDescription={true}
      variant="studio"
    />
  );
}
